import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';

const footerLinks = {
  快速导航: [
    { label: '首页', to: '/' },
    { label: '游戏大厅', to: '/category/qipai' },
    { label: '优惠活动', to: '/category/qipai' },
    { label: '新闻资讯', to: '/article/a1' },
    { label: '关于我们', to: '/about' },
  ],
  热门游戏: [
    { label: '欢乐斗地主', to: '/category/qipai' },
    { label: '经典麻将', to: '/category/qipai' },
    { label: '金蟾捕鱼', to: '/category/buyu' },
    { label: '德州扑克', to: '/category/qipai' },
    { label: 'NBA竞猜', to: '/category/tiyu' },
  ],
  游戏分类: [
    { label: '棋牌游戏', to: '/category/qipai' },
    { label: '电子游艺', to: '/category/dianzi' },
    { label: '体育竞技', to: '/category/tiyu' },
    { label: '捕鱼游戏', to: '/category/buyu' },
    { label: '彩票游戏', to: '/category/caipiao' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gamepad-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">{siteConfig.name}</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed mb-4">
              {siteConfig.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a href={siteConfig.socialLinks.weibo} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500/20 text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href={siteConfig.socialLinks.wechat} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500/20 text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href={siteConfig.socialLinks.qq} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500/20 text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-background-50 font-medium mb-4 text-sm">
                <a href={`#${title}`} className="hover:text-primary-400 transition-colors cursor-pointer">{title}</a>
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有 | 粤ICP备XXXXXXXX号
          </p>
          <p className="text-xs text-background-50/50">
            健康游戏忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。
          </p>
        </div>
      </div>
    </footer>
  );
}